<template>
  <v-dialog
      v-model="active"
      :max-width="maxWidth"
      class="dialog"
      transition="scale-transition"
      :persistent="sessionExpiredMode"
  >
    <v-card class="dialog-container">
      <div class="dialog-header">
        <v-btn
            icon
            color="black_white"
            @click="sessionExpiredMode ? goToSessionExpired : close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="dialog-content">
        <ui-typography class="mb-8" tag="h5" name="h5">Error</ui-typography>
        <div class="flex-column my-6" v-if="isHTML" v-html="error"></div>
        <ui-typography class="mb-4" name="body2" v-else>{{
            error
          }}
        </ui-typography>
        <div class="d-flex align-center mb-10 ">
          <ui-typography name="body2" color="gray" v-if="xTraceId" class="mr-2">{{
            xTraceId
          }}
          <v-btn color="gray1" @click="copyXTraceId()" icon>
            <v-icon size="18" :color="colorCopyBtn">mdi-content-copy</v-icon>
          </v-btn>
        </ui-typography>
        </div>
        <v-btn v-if="sessionExpiredMode" @click="goToSessionExpired" color="primary" block>Ok</v-btn>
        <v-btn v-else @click="close" color="primary" block>Ok</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import UiTypography from "@/components/ui/Typography/Typography";
import { logout, copyToClipboard } from "@/helpers/utils";
import { mapMutations, mapGetters } from 'vuex';

export default {
  name: "Error",
  components: { UiTypography },
  props: {
    error: {
      type: String,
      default: "",
    },
    redirectUrl: {
      type: String,
      default: "",
    },
    isHTML : {
      type: Boolean,
      default: false
    },
    sessionExpiredMode : {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: null
    }
  },
  data() {
    return { 
      active: false,
      colorCopyBtn: 'grey'
    };
  },
  methods: {
    ...mapMutations(["CLEAR_X_TRACE_ID"]),
    close() {
      this.CLEAR_X_TRACE_ID()
      this.active = false;
      // Call the onClose callback if provided
      if (this.onClose) {
        this.onClose();
      }
    },
    open() {
      this.active = true;
    },
    copyXTraceId() {
      copyToClipboard(this.xTraceId, 'Trace ID')
      this.colorCopyBtn = 'green'
    },

    async goToSessionExpired() {
      await logout();
      this.close();
      window.location.href = '/app/login';
    },
  },
  mounted() {
    if (this.redirectUrl && this.$route.name !== this.redirectUrl) {
      this.$router.replace({ name: this.redirectUrl });
    }
    if (this.error) {
      this.open();
    }
  },
  computed: {
    ...mapGetters(['xTraceId']),
    maxWidth() {
      return typeof this.error === "string" ? "460" : "768";
    },
  },
};
</script>

<style lang="scss">
.dialog {
  &-right {
    right: 0;
    background: #000;
  }

  &-container {
    min-width: 200px;
    min-height: 200px;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 32px 40px 36px 40px !important;
    position: relative
  }

  &-trigger {
    &-container {
      display: flex;
    }
  }

  &-header {
    display: flex;
    position: absolute;
    justify-content: flex-end;
    top: 10px;
    right: 10px;
  }

  &-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    flex-grow: 1;
  }
}
</style>
